import React, { useCallback } from 'react';

import { useNavigate } from 'react-router-dom';

import { SeoHead } from 'components';
import { RouteNames } from '../../constants';
import CouponList from './CouponList';

const HistoryCouponsList = props => {
  const navigate = useNavigate();
  const now = new Date();

  const filterFunction = coupon => {
    const expiryDate = new Date(coupon.expiry_time);
    return (
      expiryDate < now ||
      coupon.state === 'accepted' ||
      coupon.state === 'rejected' ||
      coupon.state === 'waiting' ||
      coupon.state === 'expired'
    );
  };

  const handleCouponPress = useCallback(
    applyCoupon => {
      if (applyCoupon?.coupon) {
        navigate(RouteNames.COUPONS_RESERVED, { state: { reservedData: applyCoupon } });
      }
    },
    [navigate],
  );

  return (
    <>
      <SeoHead title="Coupon History" noIndex />
      <CouponList {...props} filterFunction={filterFunction} enableButton={false} onCouponPress={handleCouponPress} />
    </>
  );
};

export default HistoryCouponsList;